import React, { useState } from "react";
import styled from "styled-components";
import Header from "./Header";
import Footer from "./Footer";
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
    try {
      const response = await fetch(`${API_URL}forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage("Password reset email sent.");
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Network error. Please try again.");
    }
  };

  return (
    <div>
      <Header />
      <Wrapper>
        <Form onSubmit={handleSubmit}>
          <Title>{t('forgot.title') || "Forgot Password"}</Title>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('forgot.email') || "Enter your email"}
            required
          />
          <Button type="submit">{t('forgot.send') || "Send Reset Email"}</Button>
          {message && <Message>{message}</Message>}
        </Form>
      </Wrapper>
      <Footer />
    </div>
  );
};

export default ForgotPassword;

const Wrapper = styled.div`
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background:linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
`;

const Form = styled.form`
  background-color: rgba(255,255,255,0.9);
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Title = styled.h2`
  margin: 0;
  text-align: center;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid gray;
`;

const Button = styled.button`
  padding: 10px;
  background-color: rgba(148,163,135,1);
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const Message = styled.p`
  text-align: center;
  font-weight: bold;
  color: red;
`;
